let selectedEpisodeIds = [];
const multiEventIdInput = document.getElementById('multievent_ids');
const { totalEpisodes } = window;

const initialiseEpisodeIds = () => {
  for (let i = 1; i < totalEpisodes; i += 1) {
    const episodeCheckbox = document.querySelector(`[name="episode-${i}"]`);
    if (episodeCheckbox.checked) {
      selectedEpisodeIds.push(episodeCheckbox.value);
    }
  }
};

const handleAllEpisodesClicked = () => {
  const allEpisodesCheckbox = document.querySelector(`[name="episode-all"]`);
  if (allEpisodesCheckbox.checked) {
    // Check all checkboxes and add to array
    for (let i = 1; i < totalEpisodes; i += 1) {
      const episodeCheckbox = document.querySelector(`[name="episode-${i}"]`);
      episodeCheckbox.checked = true;
      selectedEpisodeIds.push(episodeCheckbox.value);
    }
  } else {
    // Uncheck all checkboxes and clear array
    for (let i = 1; i < totalEpisodes; i += 1) {
      const episode = document.querySelector(`[name="episode-${i}"]`);
      episode.checked = false;
    }
    selectedEpisodeIds = [];
  }
};

const setupAllEpisodesListener = () => {
  const checkbox = document.querySelector(`[name="episode-all"]`);
  if (checkbox) {
    checkbox.addEventListener('click', handleAllEpisodesClicked);
  }
};

const selectEpisode = episodeCheckbox => {
  if (episodeCheckbox.checked) {
    if (!selectedEpisodeIds.includes(episodeCheckbox.value)) {
      selectedEpisodeIds.push(episodeCheckbox.value);
    }
  } else {
    const index = selectedEpisodeIds.indexOf(episodeCheckbox.value);
    if (index > -1) {
      selectedEpisodeIds.splice(index, 1);
    }
    const allEpisodesCheckbox = document.querySelector(`[name="episode-all"]`);
    if (allEpisodesCheckbox.checked) {
      allEpisodesCheckbox.checked = false;
    }
  }
};

const setupEpisodes = () => {
  // Adds listener for all Episode checkboxes
  for (let i = 1; i < totalEpisodes; i += 1) {
    const episodeCheckbox = document.querySelector(`[name="episode-${i}"]`);
    if (episodeCheckbox) {
      episodeCheckbox.addEventListener('click', () => {
        selectEpisode(episodeCheckbox);
      });
    }
  }
};

const handleMultiEventIds = () => {
  // reset value each time form is submitted
  multiEventIdInput.value = '';
  selectedEpisodeIds.forEach(eventId => {
    /* eslint-disable no-unused-expressions */
    multiEventIdInput.value === ''
      ? (multiEventIdInput.value = eventId)
      : (multiEventIdInput.value = `${multiEventIdInput.value},${eventId}`);
  });
};

const showUnexpectedError = () => {
  const errMsg = document.getElementById('moos-error');
  errMsg.classList.remove('is-hidden');
};

const removeFormErrors = () => {
  const errMsg = document.getElementById('moos-error');
  errMsg.classList.add('is-hidden');
};
const handleFormSubmissionErrors = (form, response) => {
  if (response.errors) {
    response.errors.forEach(error => {
      const field = form.querySelector(`#form-row-${error.field}`);

      if (field) {
        const $error = document.createElement('span');
        $error.classList.add('form-error');
        $error.innerText = error.message;
        field.appendChild($error);
      }
    });

    return;
  }

  showUnexpectedError(form);
};

const setPersonalWatchNowLinks = response => {
  const userEmail = response.on24_response.email;
  const onDemandSection = document.getElementById('on-demand-episodes');
  const buttonLinks = onDemandSection.querySelectorAll('a.wp-block-button__link');
  buttonLinks.forEach(link => {
    /* eslint-disable no-param-reassign */
    link.href = `${link.href}?mode=login&email=${userEmail}`;
  });
};

const handleFormSuccess = response => {
  setPersonalWatchNowLinks(response);
  selectedEpisodeIds.forEach(episodeId => {
    // set only selected episodes to display
    const episode = document.getElementById(`ep-${episodeId}`);
    if (episode) {
      episode.style.display = 'block';
    }
  });
  const moosRegistration = document.getElementById('moos-registration');
  if (moosRegistration) {
    moosRegistration.style.display = 'none';
  }
  const moosOverview = document.getElementById('moos-overview');
  if (moosOverview) {
    moosOverview.style.display = 'none';
  }
  const moosEpisodes = document.getElementById('moos-episodes');
  if (moosEpisodes) {
    moosEpisodes.style.display = 'none';
  }
  const moosPresenters = document.getElementById('moos-presenters');
  if (moosPresenters) {
    moosPresenters.style.display = 'none';
  }
  const moosFeedback = document.getElementById('moos-feedback');
  if (moosFeedback) {
    moosFeedback.style.display = 'none';
  }
  const moosContact = document.getElementById('moos-contact-us');
  if (moosContact) {
    moosContact.style.display = 'block';
  }
  const secondaryNav = document.getElementsByClassName('secondaryNav-list');
  if (secondaryNav && secondaryNav[0]) {
    secondaryNav[0].style.display = 'none';
  }
  const moosRegistrationSuccess = document.getElementById('registration-success');
  if (moosRegistrationSuccess) {
    moosRegistrationSuccess.style.display = 'block';
  }
  window.scrollTo(0, 0);
};

const handleFormSubmission = event => {
  event.preventDefault();
  handleMultiEventIds();
  removeFormErrors();
  const form = event.target;
  const formData = new FormData(form);
  const jsonData = {};

  /* eslint-disable no-restricted-syntax */
  for (const [key, value] of formData.entries()) {
    jsonData[key] = value;
  }
  fetch(`${window.restUrl}on24/v1/register`, {
    method: 'POST',
    body: JSON.stringify(jsonData),
    headers: { 'Content-Type': 'application/json' },
  })
    .then(response => response.json())
    .then(response => {
      if (response.status !== 'success') {
        handleFormSubmissionErrors(form, response);
        return;
      }

      handleFormSuccess(response);
    })
    .catch(() => showUnexpectedError(form));
};

const setupSubmit = () => {
  const form = document.getElementById('register-form');
  if (form) {
    form.addEventListener('submit', handleFormSubmission);
  }
};

const setupHiddenElements = () => {
  const contact = document.getElementById('moos-contact-us');
  if (contact) {
    contact.style.display = 'none';
  }
};

setupAllEpisodesListener();
setupEpisodes();
setupSubmit();
setupHiddenElements();
initialiseEpisodeIds();
